<template>
  <div id='content'>
    <div id='product-advantages'>
      <span class='zh-name'>产品优势</span>
      <span class='en-name'>PRODUCT ADVANTAGE</span>
      <div class='advantages-content'>
        <div class='advantage' v-for='(item, index) in advantageList' :key='index'>
          <svg-icon class='advantage-icon' :iconName='item.icon'></svg-icon> 
          <div class='advantage-name'>{{item.name}}</div>
          <div class='advantage-desc'>{{item.desc}}</div>
        </div>
      </div>
    </div>
    <div id='product-features'>
      <div class='features-null-box'></div>
      <span class='zh-name'>产品功能</span>
      <span class='en-name'>PRODUCT FEATURES</span> 
      <div class='features-bg-box'>
        <div class='features-content'>
          <div class='feature' v-for='(item, index) in featureList' :key='index' :style="{backgroundImage: 'url(' + item.bg + ')', backgroundRepeat: 'no-repeat' }">
            <div class='feature-name'>{{item.name}}</div>
            <div class='feature-desc'>{{item.desc}}</div>
          </div>
        </div>
      </div>
    </div>
    <div id='access-scheme'>
      <span class='zh-name'>接入方案</span>
      <span class='en-name'>ACCESS PLAN</span>
      <div class='scheme-content'>
        <div class='scheme-box'>
          <div class='scheme' v-for='(item, index) in schemeList' :key='index'>
            <svg-icon class='scheme-icon' :iconName='item.icon'></svg-icon> 
            <br/>
            <div class='scheme-name'>{{item.name}}</div>
            <br/>
            <div class='scheme-desc'>{{item.desc}}</div>
          </div>
        </div>
      </div>
    </div>
    <div id='app-scenario'>
      <span class='zh-name'>应用场景</span>
      <span class='en-name' style='marginBottom: 44px;'>APPLICATION SCENARIOS</span>
      <div class='scenario-content'>
        <div class='scenario-header'>
          <span class='scenario-tab tab-active' @click="selectActive(0)">智能电车/电单车</span>
          <span class='scenario-tab' @click="selectActive(1)">行车/执法记录仪</span>
        </div>
        <div class='scenario-session'>
          <!-- <img class='scenario-img' v-lazy="require('../assets/framework.png')" alt="loading..."> -->
          <img class='scenario-img' v-lazy="imgs.framework" alt="loading...">
          <div class='scenario-flex'>
            <div class='scenario' v-for='(item, index) in scenarioList' :key='index'>
              <span class='scenario-icon'></span> 
              <div class='scenario-name'>{{item.name}}</div>
              <div class='scenario-desc'>{{item.desc}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id='platform-structure'>
      <div class='null-box'></div>
      <span class='zh-name' style='marginTop: 56px;'>平台架构</span>
      <span class='en-name' style='marginBottom: 41px;'>THE PLATFORM ARCHITECTURE</span>
      <!-- <img class='platform-image' v-lazy="require('../assets/platform.png')" alt=""> -->
      <img class='platform-image' v-lazy="imgs.platform" alt="loading..."> 
    </div>
    <div class='footer'>
      <div class='footer-box'>
        <span class='phone'>联系我们：luzhaohui@didiglobal.com</span>
        <br/>
        <span class='number'>津公网安备12010002000002号</span>
        <span class='number'>津ICP备15007503号-1</span>
      </div>
    </div>
  </div>
</template>

<script>
// import debounce from 'lodash/debounce'
export default {
  components: {

  },
  data() {
    return {
      activeNumber: 0,
      advantageList: [
        {
          icon: 'icon-1',
          name: '边云融合',
          desc: '面向设备边缘、局域网边缘、网络边缘提供功能全面、覆盖全面、开源开放的边云融合能力'
        },
        {
          icon: 'icon-2',
          name: '标准协议',
          desc: '支持 MQTT/JT808 等物联网协议 实现设备与云端双向连接和控制'
        },
        {
          icon: 'icon-3',
          name: '实时分析',
          desc: '基于标准 MQTT 消息、每秒百万级的高性能、低时延、高可靠解决方案可保障双向实时数据计算'
        },
        {
          icon: 'icon-4',
          name: '安全可靠',
          desc: '丰富的设备认证与权限管理功能 并通过SSL保证数据安全传输'
        }
      ],
      featureList: [
        {
          bg: require('../assets/图1.png'),
          name: '无时无刻的安全保护',
          desc: '接入层最大可防御600Gbps的DDoS攻击，安全威胁检测服务实时防护'
        },
        {
          bg: require('../assets/图2.png'),
          name: '物理设备数字化建模',
          desc: '可对物理世界的设备数字化建模，做到协议标准化和数据结构化，加速应用开发流程'
        },
        {
          bg: require('../assets/图3.png'),
          name: '低延时远程控制设备',
          desc: '支持远程实时控制设备，结果同步返回，延时在50ms内'
        },
        {
          bg: require('../assets/图4.png'),
          name: '设备OTA升级',
          desc: '支持设备固件、软件等模块OTA升级，可指定差分、灰度、全量等多种升级策略'
        },
        {
          bg: require('../assets/图5.png'),
          name: '设备数据可实时存储',
          desc: '企业版实例自带时序存储，可实时写入和查询设备上报的结构化数据'
        },
        {
          bg: require('../assets/图6.png'),
          name: '全链路日志分析',
          desc: '设备和平台全链路日志记录，可通过关键字、TraceID、时间等维度快速检索分析'
        }
      ],
      schemeList: [
        {
          icon: 'manufacturing',
          name: '我是制造业厂商',
          desc: '将智能化模组接入我们的设备'
        },
        {
          icon: 'device',
          name: '我是智能设备厂商',
          desc: '将我们开发的设备接入滴滴物联网平台'
        },
        {
          icon: 'solution',
          name: '我是解决方案厂商',
          desc: '将已有的设备接入滴滴物联网平台'
        }
      ],
      scenarioBicycleList: [
        {
          name: '安全生产',
          desc: '提供生产线接口与上位机系统通信，设备密钥不泄露'
        },
        {
          name: '密钥管理',
          desc: '一机一密，支持动态密钥下发，运营更安全'
        },
        {
          name: '设备生命周期',
          desc: '提供包括生产、接入、调试、监控、升级等全生命周期管理能力'
        },
        {
          name: '定位辅助',
          desc: '通过卫星、蓝牙、地面站等手段，多方位提高定位精度，实现精准围栏停车'
        },
        {
          name: '固件升级',
          desc: '提供产品成长的必备通道，助力业务迭代以及设备问题的快速解决'
        }
      ],
      scenarioRecorderList: [
        {
          name: '视频直播、回放',
          desc: '支持正在记录的行程和历史行程进行直播和回放'
        },
        {
          name: '录像加密',
          desc: '所有视频加密传输并存储，保证您的信息安全'
        },
        {
          name: '车辆定位',
          desc: '支持实时定位与轨迹查看，也可用于车辆防盗'
        }
      ],
      scenarioList: [],
      zoomStyle: '',
      zoom: 1,
      wrapInitStyle: {},
      showWidth: '',
      imgs: {
        framework: require('../assets/framework.png'),
        platform: require('../assets/platform.png')
      }
    }
  },
  created() {
    this.scenarioList = this.scenarioBicycleList
  },
  watch: {
    activeNumber(newVal) {
      if (newVal === 0) {
        this.scenarioList = this.scenarioBicycleList
      } else {
        this.scenarioList = this.scenarioRecorderList
      }
    }
  },
  mounted() {
    window.onresize = () => {
      this.showWidth = document.getElementById('app').clientWidth
      if (this.showWidth > 1440) {
        this.$nextTick(() => {
          document.getElementById('homePage').style.zoom = 1
        })               
      } else {
        this.judgeBrowser()
      }
    }
    this.$nextTick(() => {
      this.showWidth = document.getElementById('app').clientWidth
      if (this.showWidth < 1441) {
        this.judgeBrowser()
      }
    }) 
  },
  methods: {
    selectActive(index) {
      let aggregate = document.getElementsByClassName('scenario-tab')
      for (let i = 0, len = aggregate.length; i < len; i++) {
        aggregate[i].classList.remove('tab-active');
      }
      aggregate[index].classList.add('tab-active')   
      this.activeNumber = index  // 代表第几个tab
    },
    // bodyScale() {
    //   var devicewidth = document.documentElement.clientWidth;//获取当前分辨率下的可视区域宽度
    //   var scale = devicewidth / 1440; // 分母——设计稿的尺寸
    //   document.body.style.zoom = scale;//放大缩小相应倍数
    // },
    judgeBrowser() {
      var userAgent = navigator.userAgent;
      var isFirefox = userAgent.indexOf('Firefox') > -1;
      var isChrome = userAgent.indexOf('Chrome') > -1;
      var isSafari = userAgent.indexOf('Safari') > -1;
      if (isFirefox) {
        this.setFirefoxZoom();
      }
      if (isChrome || isSafari) {
        this.setZoom()
      }
    },
    setZoom: function(){
      const dom = document.getElementById('homePage');
      dom.style.zoom = 1;
      const w = dom.clientWidth;
      const h = dom.clientHeight;
      const maxProportion = w / h >= 1440 / 4795;
      let zoomNum = ''
      if (w > 1440) {
        zoomNum = !maxProportion ? h / 4795 : w / 1440;
      } else {
        zoomNum = !maxProportion ? w / 1440 : h / 4795;
      }
      this.zoomStyle = `zoom: ${zoomNum};`;
      this.zoom = zoomNum
      dom.style.zoom = zoomNum
    },
    setFirefoxZoom() {
      const dom = document.getElementById('homePage');
      const w = dom.clientWidth;
      const h = dom.clientHeight;
      const maxProportion = w / h >= 1440 / 4795;
      let zoomNum = ''
      if (w > 1440) {
        zoomNum = !maxProportion ? h / 4795 : w / 1440;
      } else {
        zoomNum = !maxProportion ? w / 1440 : h / 4795;
      }
      this.zoom = zoomNum
      let childStyle = `width: 1440px;height: 4795px;position: absolute;transform:scale(${zoomNum});-moz-transform-origin: left top;`;
      this.wrapInitStyle = {
        transform: `scale(${zoomNum})`,
        transformOrigin: 'right top',
        width: '1440px',
        height: '4795px'
      };
      this.bgStyle = childStyle;
    },
  }
}
</script>
<style lang="scss" scoped>
#content {
    width: 100%;
    height: 100%;
    background-color:rgba(242, 245, 255, 1);
  }
  .zh-name {
    display: block;
    height:39px;
    line-height: 39px;
    font-family:Montserrat;
    font-weight:700;
    color:#111111;
    font-size:32px;
  }
  .en-name {
    display: block;
    height:20px;
    font-family:PingFang SC;
    color:#999999;
    font-size:14px;
    line-height:22px;
  }
  #product-advantages {
    width: 100%;
    padding: 80px 0 109px;
    .advantages-content {
      display: flex;
      justify-content: space-between;
      width: 1198px;
      margin: 0 auto;
      padding-top: 38px;
      .advantage {
        width: 281px;
        // width: 23%;
        height: 305px;  
        background-color:#ffffff;
        box-shadow:0px 6px 9px rgba(31, 96, 213, 0.1);  
        text-align: left;
        box-sizing: border-box;
        padding: 0px 27px;
        .advantage-icon {
          width: 54px;
          height: 54px;
          margin-top: 52px;
        } 
        .advantage-name {
          margin: 36px 0px 15px 0;
          height:25px;
          line-height: 25px;
          font-family:PingFang SC;
          font-weight:500;
          color:#333333;
          font-size:18px;
        }   
        .advantage-desc {
          font-family:PingFang SC;
          color:rgba(68, 68, 68, 1);
          font-size:14px;
          line-height: 22px;
        }
      }
    }
  }
  #product-features {
    width: 100%;
    background-image: url('../assets/bg-5.png');
    background-repeat: no-repeat;
    background-size: 100%;
    .features-null-box {
      background: #f2f5ff; 
      padding-top: 10px;
    }
    .zh-name {
      color: #ffffff; 
      font-weight:500; 
      font-family:PingFang SC; 
      padding-top: 70px;
    }
    .en-name {
      color: #ffffff; 
      margin-bottom: 56px;
    }
    .features-bg-box {
      width: 100%;
      background-image: url('../assets/bg-2.png');
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .features-content {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 14px;
      padding: 82px 125.5px;
      margin: -82px 0;
      width: 1189px;
      .feature {
        // position: relative;
        text-align: left;
        box-sizing: border-box;
        box-shadow:3px 3px 60px rgba(31, 96, 213, 0.1);
        padding: 60px 23px 0px;
        width: 380px;
        height: 207px;
        font-family:PingFang SC;
        color:#333333;
        .feature-name {
          height:25px;
          font-weight:500;
          font-size:18px;
          line-height: 25px;
        }
        .feature-desc {
          margin-top: 15px;
          font-size:14px;
          line-height:22px;
          height: 22px;
        }
      }
    }
  }
  #access-scheme {
    margin-top: 110px;
    padding: 82px 0 0;
    box-sizing: border-box;
    background-color: #fff;
    height: 680px;
    width: 100%;
    .scheme-content {
      height: 528px;
      background-image: url('../assets/bg-3.png');
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: right;
      background-size: contain;
      padding-left: 11%;
      // margin-right: 144px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
      margin-top: 22px;
      .scheme-box {
        margin-top: 9px;
        .scheme {
          font-family:PingFang SC;
          margin-bottom: 70px;
          .scheme-icon {
            width: 21.5px;
            height: 23.34px;
            margin-bottom: 15px;
          }
          .scheme-name {
            font-weight:500;
            color:#333333;
            font-size:18px;
            height: 25px;
            line-height: 25px;
            margin-bottom: 8px;
            display: inline-block;
          }
          .scheme-desc {
            color:#444444;
            font-size:14px;
            height: 20px;
            line-height: 20px;
            display: inline-block;
          }
        }
      }
      
    }
  }
  #app-scenario {
    margin-top: 105px;
    width: 100%;
    height: 1083px;
    background-image: url('../assets/bg-4.png');
    background-repeat: no-repeat;
    background-size: 100%;
    padding: 82px 0 107px;
    box-sizing: border-box;
    .scenario-content {
      width: 1198px;
      height: 783px;
      background-color: rgba(255, 255, 255, 0.75);
      margin: 0 auto;
      
      .scenario-header {
        height: 85px;
        border-bottom: 1px solid #dedede;
        padding: 32px 0 24.5px 47px;
        box-sizing: border-box;
        text-align: left;
        .scenario-tab {
          height:28px;
          line-height: 22px;
          font-family:PingFang SC;
          font-weight:500;
          color:#666666;
          font-size:20px;
          margin-right: 50px;
          cursor: pointer;
        }
        .tab-active {
          color:#2163da;
        }
      }
      .scenario-session {
        display: flex;
        .scenario-img {
          margin: 55px 94px 49px 73px;         
        }
        .scenario-flex {
          display: flex;
          flex-direction: column;
          margin: 28px 59px 0 0;
          .scenario {
            width: 580px;
            height: 120px;
            margin-bottom: 10px;
            box-shadow:3px 3px 10px rgba(31, 96, 213, 0.15);
            background-color:#ffffff;
            font-family:PingFang SC;
            text-align: left;
            .scenario-icon {
              display: inline-block;
              width:3px;
              height:18px;
              background-color:#4588ff;
              margin: 32px 7px -2px 27px;
            }
            .scenario-name {
              height:25px;
              line-height:22px;
              font-family:PingFang SC;
              font-weight:500;
              color:#333333;
              font-size:18px;
              display: inline-block;
            }
            .scenario-desc {
              height:20px;
              line-height:22px;
              color:#444444;
              font-size:14px;
              margin: 20px 0 0 39px 
            }
          }
        }
      }
    }
  }
  #platform-structure {
    margin-top: 70px;
    height:1153px;
    background-color:#ffffff;
    // padding: 56px 121px 31px;
    box-sizing: border-box;
    width: 100%;
    .null-box {
      width: 100%;
      height: 25px;
      background: #f2f5ff;
    }
    .platform-image {
      // margin-top: 41px;
      width: 1198px;
      margin: 0 auto;
    }
  }
  .footer {
    width: 100%;
    height:114px;
    background-color:#061d36;
    font-family:Montserrat;
    color:#c4c7cb;
    font-size:14px;
    font-weight: 400;
    padding: 30px 0 28px 542px;
    box-sizing: border-box;
    text-align: left;
    .number {
      // height:17px;
      // line-height:25px;
      margin: 22px 30px 0 0;
      display: inline-block;
    }
  }
  @media (min-width:1441px) {
  #product-features{
    background-size: 100% 90%;
    .en-name {
      margin-bottom: 0px;
    }
    .features-bg-box {
      // height: 100vh;
      padding-top: 90px;
      background-size: 100% 100%;
      margin-top: -82px;
    }
    .features-content {
      padding: 0;
      margin: 0 auto;
    }
  }
  #access-scheme {
    .scheme-content {
      padding-left: 0;
      justify-content: center;
      align-items: center;
      .scheme-box {
        // margin-left: 9%;
        width: 1189px;
        margin: 9px auto;
        .scheme {
          width: 238px;
          // margin-left: 22%;
        }
      }
    }
  }
  .footer {
    padding: 30px 0;
    .footer-box {
      margin: 0 auto;
      width: 400px;
    }
  }
}
</style>